import PropTypes from "prop-types";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate } from "@/features/shared";

const ValiditySection = ({ promotion }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Masa Berlaku
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Mulai
          </Typography>
          <Typography variant="body1">
            {formatDate(promotion.validFrom)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Berakhir
          </Typography>
          <Typography variant="body1">
            {formatDate(promotion.validTo)}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

ValiditySection.propTypes = {
  promotion: PropTypes.object.isRequired,
};

export default ValiditySection;
